import { render, staticRenderFns } from "./BrowsLayout.vue?vue&type=template&id=225d5085"
import script from "./BrowsLayout.vue?vue&type=script&lang=js"
export * from "./BrowsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports